import { EmptyGuid, Messages } from '@components/utils/constants'
import * as Yup from 'yup'

export const CHANGE_MOBILE_NO_FORM_ID = 'changeMobileNo'

export const CHANGE_MOBILE_NO_FORM_FIELDS = [
  {
    type: 'tel',
    name: 'mobileNumber',
    placeholder: 'Mobile Number',
    label: 'Mobile Number',
    className:
      'relative mb-2 mt-2 appearance-none min-w-0 w-full bg-white border border-gray-300 rounded-sm shadow-sm py-2 px-4 text-gray-900 placeholder-gray-500 focus:outline-none focus:border-black focus:ring-1 focus:ring-black',
    labelClassName: 'text-gray-700 text-sm dark:text-black',
    required: true,
    disabled: false,
    max: 10,
  },
  {
    type: 'tel',
    name: 'otp',
    placeholder: 'OTP',
    label: 'OTP',
    className:
      'relative mb-2 mt-2 appearance-none min-w-0 w-full bg-white border border-gray-300 rounded-sm shadow-sm py-2 px-4 text-gray-900 placeholder-gray-500 focus:outline-none focus:border-black focus:ring-1 focus:ring-black',
    labelClassName: 'text-gray-700 text-sm dark:text-black',
    required: false,
    disabled: false,
    max: 6,
  },
]

export const CHANGE_MOBILE_NUMBER_FORM_VALUES = {
  mobileNumber: '',
  otp: '',
}

export const PROFILE_FORM_ID = 'profileForm'

export const PROFILE_FORM_FIELDS = [
  {
    type: 'text',
    name: 'fullName',
    placeholder: 'Full Name',
    label: 'Full Name',
    className:
      'relative w-full min-w-0 px-4 py-2 mt-2 mb-2 text-gray-900 placeholder-gray-500 bg-white border border-gray-300 rounded-sm shadow-sm appearance-none focus:outline-none focus:border-black focus:ring-1 focus:ring-black',
    labelClassName: 'text-sm text-gray-700 dark:text-black',
    required: true,
    disabled: false,
  },
  {
    type: 'text',
    name: 'mobileNumber',
    placeholder: 'Mobile Number',
    label: 'Mobile Number',
    className:
      'relative w-full min-w-0 px-4 py-2 mt-2 mb-2 text-gray-900 placeholder-gray-500 bg-white border border-gray-300 rounded-sm shadow-sm appearance-none focus:outline-none focus:border-black focus:ring-1 focus:ring-black',
    labelClassName: 'text-sm text-gray-700 dark:text-black',
    required: true,
    disabled: true,
  },
  {
    type: 'text',
    name: 'email',
    placeholder: 'Email',
    label: 'Email',
    className:
      'relative w-full min-w-0 px-4 py-2 mt-2 mb-2 text-gray-900 placeholder-gray-500 bg-white border border-gray-300 rounded-sm shadow-sm appearance-none focus:outline-none focus:border-black focus:ring-1 focus:ring-black',
    labelClassName: 'text-sm text-gray-700 dark:text-black',
    required: false,
    disabled: false,
  },
  {
    type: 'date',
    name: 'birthDate',
    placeholder: 'Birth Date',
    label: 'Birth Date',
    className:
      'date-inpt relative mb-2 mt-2 appearance-none min-w-0 w-full bg-white border border-gray-300 rounded-sm shadow-sm py-2 px-4 text-gray-900 placeholder-gray-500 focus:outline-none focus:border-black focus:ring-1 focus:ring-black',
    labelClassName: 'text-gray-700 text-sm dark:text-black',
    required: false,
    disabled: false,
    dependant: true,
  },
  {
    type: 'singleSelectButtonGroup',
    name: 'gender',
    placeholder: '',
    label: 'Gender',
    labelClassName:
      'text-sm sm:text-base text-primary opacity-60 font-bold mb-3 dark:text-black',
    options: [
      {
        label: 'Female',
        value: 'Female',
      },
      {
        label: 'Male',
        value: 'Male',
      },
      {
        label: 'Other',
        value: 'Other',
      },
    ],
    activeOptionIndex: '',
    optionClassName: 'inline-block mb-3 mr-2',
    lastOptionClassName: 'inline-block mb-3 mr-2',
    required: false,
    disabled: false,
  },
]

export const PROFILE_FORM_SCHEMA = Yup.object().shape({
  id: Yup.string().notRequired(),
  fullName: Yup.string()
    .min(3, Messages.Validations.Profile['NAME_MIN_LENGTH'])
    .required(Messages.Validations.Profile['NAME_REQUIRED'])
    .matches(Messages.Validations.RegularExpressions.FULL_NAME, {
      message: Messages.Validations.Profile['NAME_INPUT'],
    }),
  mobileNumber: Yup.string()
    .max(10)
    .required(Messages.Validations.Profile['MOBILE_NUMBER_REQUIRED'])
    .matches(Messages.Validations.RegularExpressions.MOBILE_NUMBER, {
      message: Messages.Validations.Profile['MOBILE_NUMBER_INPUT'],
    }),
  email: Yup.string()
    // .required(Messages.Validations.Profile["EMAIL_REQUIRED"])
    .matches(Messages.Validations.RegularExpressions.EMAIL, {
      message: Messages.Validations.Profile['EMAIL_INPUT'],
    }),
  birthDate: Yup.string().test(
    'birthDate',
    'Birth date should not be greater than current date',
    (value: string | undefined) => {
      if (value && value != '0-00-00') {
        return new Date(value).getTime() < new Date().getTime()
      }
      return true
    }
  ),
  gender: Yup.string(),
})

export const DEFAULT_PROFILE_VALUES = {
  id: EmptyGuid,
  fullName: '',
  mobileNumber: '',
  email: '',
  birthDate: '',
  gender: '',
}
